import { RESOURCE } from '@src/constants';
import api from './api';

const getCaptionTemplates = async () => {
  const response = await api({
    method: 'GET',
    url: RESOURCE.CAPTION_TEMPLATES,
  });
  return response;
};

const createProjectCaptionTemplate = async ({ projectId, config }) => {
  const response = await api({
    method: 'POST',
    url: RESOURCE.CAPTION_TEMPLATES,
    data: { projectId, config },
  });
  return response;
};

const updateProjectCaptionTemplate = async (captionTemplateId, { config }) => {
  const response = await api({
    method: 'PUT',
    url: `${RESOURCE.CAPTION_TEMPLATES}/${captionTemplateId}`,
    data: { config },
  });
  return response;
};

export {
  getCaptionTemplates,
  createProjectCaptionTemplate,
  updateProjectCaptionTemplate,
};
